attachEvent('.secondary-nav__title', 'click', (el) => {
  const parentElem = el.target.closest('.secondary-nav');
  parentElem.classList.toggle('is-open');
  const dropdown = parentElem.querySelector('.secondary-nav__nav');
  slideToggle(dropdown, 300, 'block');
});
